import React, { useState, useEffect } from 'react';
import { CheckCircle } from '@mui/icons-material';
import './index.css';
import MuiTableHeader from '../../../uiComponents/MuiTable/MuiTableHeader.js';
import {stableSort, getComparator} from '../../../uiComponents/MuiTable/MuiHelper';
import { StyledPaper, StyledTable, StyledTableRow, StyledTableCell } from '../../../uiComponents/MuiTable/StyledTable.js';
import { 
  TableBody,
  TableContainer,
} from '@mui/material';

const headCells = [
  { label: 'Name', id: 'user.fullName', numeric: false, disablePadding: false },
  { label: 'In Progress', id: 'inProgress', numeric: false, disablePadding: false, align: 'center' },
  { label: 'Completed', id: 'completed', numeric: false, disablePadding: false, align: 'center' }, 
  { label: 'Classification', id: 'programClassification', numeric: false, disablePadding: false },
  { label: 'Comments', id: 'comment', numeric: false, disablePadding: false },
];

const AssignedInterpreters = ({ data, childKey }) => {
  const [tableData, setTableData] = useState(data);
  const [order, setOrder] = useState('asc'); //default sort direction
  const [orderBy, setOrderBy] = useState('user.fullName'); //default sort column for table

  useEffect(() => {
    setTableData(data)
  }, [data]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const inProgressCell = (row) => {
    return row.interpretationStatus != "Completed" ? (
      <div><CheckCircle className="interpreterCheckCircle" style={{ verticalAlign: 'middle' }}/></div>
    ) : ('');
  };

  const completionCell = (row) => {
    return row.interpretationStatus == "Completed" ? (
      <div><CheckCircle className="interpreterCheckCircle" style={{ verticalAlign: 'middle', fontSize: '1rem' }}/></div>
    ) : ('');
  };

  return (
    <div key={childKey}>
       <StyledPaper>
        <TableContainer>
          <StyledTable
            size='small'
            aria-label="assigned interpreters table" >
            <MuiTableHeader 
              headCells={headCells} 
              order={order}  
              orderBy={orderBy} 
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {stableSort(tableData, getComparator(order, orderBy))
                .map((row, index) => {
                return (
                  <StyledTableRow tabIndex={-1} key={index}>
                    <StyledTableCell style={{width: '20%'}}>{row.user.fullName}</StyledTableCell>
                    <StyledTableCell style={{width: '12.5%'}} align="center">{inProgressCell(row)}</StyledTableCell>
                    <StyledTableCell style={{width: '12.5%'}} align="center">{completionCell(row)}</StyledTableCell> 
                    <StyledTableCell style={{width: '12.5%'}}>{row.programClassification}</StyledTableCell>
                    <StyledTableCell style={{width: '42.5%'}}>{row.comment}</StyledTableCell>
                  </StyledTableRow>
                );
              })}
            </TableBody>
          </StyledTable>
        </TableContainer>
      </StyledPaper>
    </div>
  );
};

export default AssignedInterpreters;